<script>export let primary = false;
export let secondary = false;
export let custom = false;
export let disabled = false;
export let noborder = false;
export let variant = "desktop";
</script>

<style>.button {
  background-color: hsl(var(--color-N20));
  border: solid 1px hsl(var(--color-N32));
  box-sizing: border-box;
  color: hsl(var(--color-font));
  cursor: pointer;
  font-size: var(--font-size, 12px);
  text-align: center;
  transition: opacity 0.5s ease-out;
  font-weight: 700;
  vertical-align: middle;
  display: flex;
  align-items: center;
  border-radius: var(--border-radius, 2px);
  align-self: var(--align-self, stretch);
  padding: var(--padding, 8px 16px);
  justify-content: center;
  /* inner div is required to make text or other element to be vericaly aligned */
}
.button.primary {
  background-color: hsl(var(--color-accent));
  border: solid 1px hsl(var(--color-accent));
  color: hsl(var(--color-font-accent));
}
.button.primary:hover.desktop {
  background-color: hsl(var(--color-A120));
  border: solid 1px hsl(var(--color-A120));
}
.button.primary.disabled {
  background-color: hsl(var(--color-A30));
  border: solid 1px hsl(var(--color-A30));
  color: hsl(var(--color-N32));
}
.button.secondary {
  background-color: hsl(var(--color-accent)/16%);
  border: 1px solid hsl(var(--color-accent));
  border-radius: 4px;
  color: hsl(var(--color-accent));
}
.button.custom, .button.custom.disabled {
  background-color: var(--button-color, hsl(var(--color-accent)));
  border: 1px solid var(--button-border-color, hsl(var(--color-accent)));
  border-radius: 4px;
  color: var(--button-text-color, hsl(var(--color-font-accent)));
}
.button.custom.disabled {
  opacity: 0.3;
}
.button:active {
  background-color: hsl(var(--color-N32));
}
.button:active.primary {
  background-color: hsl(var(--color-accent));
}
.button.noborder {
  background: none;
}
.button.disabled {
  background-color: hsl(var(--color-accent)/30%);
  pointer-events: none;
  color: hsl(var(--color-font-accent)/30%);
  border: none;
}
.button div {
  display: block;
  white-space: break-spaces;
}</style>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  class="button {variant}"
  class:primary
  class:secondary
  class:custom
  class:disabled
  class:noborder
  on:click>
  <div>
    <slot>Example button!</slot>
  </div>
</div>
